import ProjectCompletedReminderModalModule from './project-completed-reminder-modal.module'

export default ProjectCompletedReminderModalModule
